import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions/index';
import { injectIntl } from 'react-intl';
import { getSortOptionsForApp } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

class CustomFlexController extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    setFlexSortDropDown = () => {
        let defaultOptions = [
            { value: 'id|DESC', displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.sorting" }) },
            { value: getSortOptionsForApp('rechte_produktionsdatum|DESC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.dateDESC" }) },
            { value: getSortOptionsForApp('rechte_produktionsdatum|ASC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.dateASC" }) },
            { value: getSortOptionsForApp('created|DESC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.uploadDESC" }) },
            { value: getSortOptionsForApp('created|ASC', this.props.customConfigClipInfoForApp), displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.uploadASC" }) },
            { value: 'media|DESC', displayValue: this.props.intl.formatMessage({ id: "page.cliplist.sorting.type" }) },
        ];

        let ddSortOptions = null;
        if (DataUtil.isFrancetv()) {
            const { metadata } = this.props.customFlexAppConfig;
            if (metadata) {
                let sortOptions = metadata.filter(item => (item.params && item.params.sortoption) ? true : false);
                if (sortOptions && sortOptions.length > 0) {
                    let options = [];
                    sortOptions.forEach((item, i) => {
                        let display = this.props.intl.formatMessage({ id: `${item.intl}` });
                        options.push({ value: `${item.field}|DESC`, displayValue: `${display} DESC` },
                            { value: `${item.field}|ASC`, displayValue: `${display} ASC` });

                    });
                    ddSortOptions = options;
                }
            }
        } else {
            ddSortOptions = defaultOptions;
        }
        this.props.getCustomFlexAppConfig({ ddSortOptions });
    }

    setFlexViewList = () => {
        if (DataUtil.isFrancetv()) {
            const { metadata } = this.props.customFlexAppConfig;

            if (metadata) {
                let viewListItems = metadata.filter(item => (item.params && item.params.viewlist) ? true : false);
                viewListItems = viewListItems.map(item => ({ ...item, viewListOrder: item.params.viewlist.order }))
                viewListItems = DataUtil.sortByProperty(viewListItems, { prop: "viewListOrder" });
                this.props.getCustomFlexAppConfig({ viewListItems });
            }
        }
    }

    getWorkflows = (action) => {
        let workflows = [];
        if (this.props.user.originalObject && this.props.user.originalObject.g) {
            let original = this.props.user.originalObject.g.get('workflows', { 'action': action });

            if (original) {
                for (let id in original) {
                    workflows.push({ name: original[id], id: id });
                }
            }
        }
        return workflows;
    }

    setWorkflows = () => {
        if (DataUtil.isFrancetv()) {
            let workflows = this.getWorkflows("upload");
            if (workflows) this.props.getCustomFlexAppConfig({ workflows });
            let transcodeWorkflows = this.getWorkflows("transcode");
            if (transcodeWorkflows) this.props.getCustomFlexAppConfig({ transcodeWorkflows });
        }
    }
    componentDidMount() {
        this.setFlexSortDropDown();
        this.setFlexViewList();
        this.setWorkflows();
    }

    render() {
        return (<div></div>);
    }
}

const mapStateToProps = (state) => ({
    customFlexAppConfig: state.customData.customFlexAppConfig,
    user: state.auth.user,
    uiConfig: state.customData.customUiConfigForApp,

});
const mapDispatchToProps = (dispatch) => {
    return {
        getCustomFlexAppConfig: (option) => dispatch(actions.getCustomFlexAppConfig(option)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CustomFlexController));